import React, { useState, useEffect } from 'react';
import { LiaTimesSolid } from 'react-icons/lia';
import { useNavigate } from 'react-router-dom';

function SelecctModal({
  handleOpenandCloseModal,
  modalArrayContent,
  setClickedItem,
  trackModalState,
  title,
  offerDetails,
}) {
  //   const [clickedItem, setClickedItem] = useState(
  //     modalArrayContent.length && modalArrayContent[0]
  //   );

  const navigate = useNavigate();

  const [searchQuery, setSearchQuery] = useState('');
  const [searchResult, setSearchResult] = useState([]);
  const handleChange = (e) => setSearchQuery(e.target.value);

  const handleClickedItem = (id) => {
    const clickedItemObject = modalArrayContent?.find((data) => {
      return data.id === id;
    });
    setClickedItem(clickedItemObject);
    handleOpenandCloseModal(trackModalState);
    setClickedItem(clickedItemObject);
    //  setItemClicked(clickedItemObject);
  };

  useEffect(() => {
    if (modalArrayContent?.length)
      // setClickedItem(modalArrayContent[0]);
      setSearchResult(modalArrayContent);
  }, [modalArrayContent]);

  // filter items
  useEffect(() => {
    const query = modalArrayContent?.filter((item) => {
      return item?.name?.toUpperCase()?.includes(searchQuery?.toUpperCase());
    });

    setSearchResult(query);
  }, [modalArrayContent, searchQuery]);
  // //sorting list iems
  modalArrayContent?.sort((a, b) => {
    let fa = a?.name?.toLowerCase();
    let fb = b?.name?.toLowerCase();

    if (fa < fb) {
      return -1;
    }
    if (fa > fb) {
      return 1;
    }
    return 0;
  });

  return (
    <div className=' flex flex-col gap-3 w-[25rem] rounded h-[414px] bg-p-wh shadow-lg fixed pt-8 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2'>
      <div className='flex flex-row justify-between pb-4 px-6'>
        <h2 className='text-xl font-semibold'>{title}</h2>{' '}
        <span
          className=' flex items-center justify-center w-8 h-8 rounded-full text-2xl  text-s-bk text-right cursor-pointer hover:text-p-bk'
          onClick={() => handleOpenandCloseModal('close')}
        >
          <LiaTimesSolid />
        </span>
      </div>
      <div className='mx-6'>
        {' '}
        <input
          type='text'
          className='focus:outline-none focus:ring focus:b-mc w-full px-4 h-11 rounded border-hf '
          name='amount'
          value={searchQuery}
          onChange={handleChange}
          placeholder='Search'
        />
      </div>

      <ul className='max-h-[265px] overflow-y-scroll'>
        {!searchResult?.length ? (
          <span className='py-3 hover:bg-p-bk/5 px-6 italic'>
            No matching currency
          </span>
        ) : (
          searchResult
            .filter(
              (data) => data.currencyId === offerDetails?.quote_currency?.id
            )
            .map((data) => (
              <li
                key={data.id}
                className='flex flex-row items-center justify-between py-3 hover:bg-p-bk/5 px-6 cursor-pointer'
                onClick={() => handleClickedItem(data.id)}
              >
                <span className='flex flex-row gap-3 items-center'>
                  <img src={data?.flag} alt={data.name} className='w-6 h-4' />
                  {data.name}
                </span>
                <span className='text-right'> {data.code}</span>
              </li>
            ))
        )}
      </ul>
      <div className='px-6 my-6'>
        <button
          className='text-p-wh justify-center  hover:bg-b-mc/75 focus:bg-b-mc/80 px-4 py-2.5 w-full font-semibold disabled:bg-b-mct bg-b-mc rounded-lg'
          onClick={() => navigate('/paymentmethod')}
        >
          Add Bank Account
        </button>
      </div>
    </div>
  );
}

export default SelecctModal;
